<template>
  <div>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="">
      <h2>Dados da campanha</h2>
      <!-- begin: OTHER campaign types upsert -->
      <p>
        <strong>Nome:</strong> {{ campaign?.name }}<br/>
        <strong>Status:</strong> {{ campaign.status | formatCampaignStatus }}<br/>
        <strong>Tipo:</strong> {{ campaign.type | formatCampaignType }}<br/>
        <strong>Valor:</strong> {{ campaign.amount / 100 | formatMoney }}<br/>
        <strong>Meta de CPV:</strong> {{ campaign.cpv_target_amount / 100 | formatMoney }}
      </p>
      <h2>Vídeo</h2>
      <p>
        <strong>Nome:</strong> {{ creative.name }}<br/>
        <strong>Link do vídeo:</strong> <a :href="`https://youtube.com/watch?v=${creative.youtube_id}`" target="_blank">{{ `https://youtube.com/watch?v=${creative.youtube_id}` }}</a><br/>
        <strong>ID do vídeo:</strong> {{ creative.youtube_id }}<br/>
        <strong>Headline:</strong> {{  creative.headline }}<br/>
        <strong>Descrição:</strong> {{ creative.body_text }}<br/>
        <strong>CTA:</strong> {{ creative.call_to_action }}<br/>
        <strong>URL:</strong> {{ creative.url }}
      </p>
      <hr>
      <div class="mt-8 mb-8">
        <h2> Cadastrar campanha na plataforma {{ campaign.platform }} </h2>
        <p>Finalize o cadastro da campanha na plataforma do parceiro e, por fim, inclua o ID da line abaixo.</p>
        <div class="text-center mt-5">
          <a
            :href="`https://displayvideo.google.com/ng_nav/p/660702863/a/${campaign.advertiser.google_id}/c/${campaign.platform_id}/io/${currentPackage.platform_id}/explorerlis`"
            class="btn btn-sm btn-primary"
            target="_blank"
          >
            Cadastrar
          </a>
          <p class="mt-2">
            <strong>Nome da line:</strong> Line - {{ campaign.name }}
          </p>
        </div>
      </div>
      <!-- end: OTHER campaign types upsert -->

      <hr>
      <div class="mt-8">
        <h2> Vincular Campanha </h2>
        <form @submit.prevent="submit" class="mt-2">
          <div class="form-group mb-3 col-lg-4">
            <label class="form-label text-start">Insira o ID da line na plataforma {{ campaign.platform }}</label>
            <input type="text" class="form-control" placeholder="ID da linha" v-model.trim="form.platform_id" />
          </div>
          <div class="mt-3 text-center">
            <Button
              type="submit"
              class="btn btn-primary"
              :loading="loader"
            >
              Enviar
            </Button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'UpsertYoutubeCampaignForm',
  components: {
    AlertWraper,
    Button
  },
  props: ['campaign'],
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false,
      form: {
        platform_id: ''
      }
    }
  },
  created () {
    this.form.platform_id = this.currentLine.platform_id
  },
  computed: {
    /**
     * Get creative
     */
    creative () {
      if (!this.campaign) return null
      return this.campaign.creatives[0]
    },
    /**
     * Get current line
     */
    currentLine () {
      if (!this.campaign) return null
      return this.campaign.packages[0].lines[0]
    },
    /**
     * Get current package
     */
    currentPackage () {
      if (!this.campaign) return null
      return this.campaign.packages[0]
    }
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      this.content = null
      try {
        const campaign = await CampaignsService.upsertYoutubeCampaignOnPlatform({
          campaignId: this.campaign.id,
          platformId: this.form.platform_id
        })
        this.$emit('upserted', campaign)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
